import React from 'react';
//import { getIcons } from '_helpers';

export { FleetBusTypesCard };
 
function FleetBusTypesCard({ data }) {

    if (!data) {
        return null; 
    } 

    return (
        <div className={`flex side-panel-card shadow`}>
            <div className="flex flex-col gap-4 px-4 pb-2 w-full">
                {/* Première ligne : titre */}
                <div className="flex flex-col gap-4 w-full text-center">
                    <div className="flex-1 text-2xl uppercase">Types de véhicules</div>                    
                </div>
                {/* Deuxième ligne divisée en 4 sur la longueur */}    
                <div className='flex flex-col gap-4 w-full'>  
                    {data.length === 0 ? (
                        <div  className="flex text-center items-center justify-center">
                            Aucun bus enregistré
                        </div>
                    ) : (                    
                    data.map((item, index) => (
                        <div key={index} className="flex text-center items-center justify-center">                            
                            <div className="text-3xl font-bold mr-2">{item.nb}</div>
                            <div className="text-xl ml-4"> {item.type}</div>
                            <div className="text-xl ml-4"> {item.type_batt}</div>
                            <div className="text-xl ml-4"> {item.nb_packs} packs</div>
                            <div className="text-xl ml-4"> {item.puissance}kWh</div>

                        </div>
                    )))}       
                </div>
            </div>
        </div>
    );
};
